module.exports = __webpack_public_path__ + "img/replace.b7dc17e7.svg";